module.exports = __webpack_public_path__ + "static/img/lgw.b089fe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lgw.png
// module id = NAV7
// module chunks = 0